export const SEARCH_INPUT_SOURCING_FILTER1_BUYER =
  'SEARCH_INPUT_SOURCING_FILTER1_BUYER'
export const SEARCH_OPTION_SOURCING_FILTER2_BUYER =
  'SEARCH_OPTION_SOURCING_FILTER2_BUYER'
export const SEARCH_OPTION_SOURCING_FILTER3_BUYER =
  'SEARCH_OPTION_SOURCING_FILTER3_BUYER'
export const SEARCH_OPTION_SOURCING_FILTER4_BUYER =
  'SEARCH_OPTION_SOURCING_FILTER4_BUYER'
export const SEARCH_OPTION_SOURCING_FILTER5_BUYER =
  'SEARCH_OPTION_SOURCING_FILTER5_BUYER'
